import React, { Fragment, useState, useEffect } from "react";
import tools from "../../components/tools/tools";
import Select from '../../components/select';
import Loader from '../common/loader';
import { useNavigate } from 'react-router-dom'; // Import navigation hook
import '../../assets/scss/components/checkbox.scss'; // Import the SCSS file for checkbox styles

const Default = ({
    esMesaRegistro,
}) => {
    const [printers, setPrinters] = useState([]);
    const [events, setEvents] = useState([]);
    const [psp, setPSP] = useState([]);
    const [selectedPrinterEtiquetas, setSelectedPrinterEtiquetas] = useState('');
    const [selectedPrinterDinamicas, setSelectedPrinterDinamicas] = useState('');
    const [selectedEvent, setSelectedEvent] = useState('');
    const [selectedPSP, setSelectedPSP] = useState('');
    const [labelWidth, setLabelWidth] = useState(''); 
    const [labelHeight, setLabelHeight] = useState(''); 
    const [ticketWidth, setTicketWidth] = useState(''); 
    const [ticketHeight, setTicketHeight] = useState(''); 
    const [fontSizeName, setFontSizeName] = useState(''); 
    const [fontSizeCompany, setFontSizeCompany] = useState(''); 
    const [fontSizeOther, setFontSizeOther] = useState(''); 
    const [printerStatus, setPrinterStatus] = useState(null); // null = no printer selected, true = connected, false = disconnected
    const [isMesaExpositor, setIsMesaExpositor] = useState(false); // State for "Es Mesa Expositor"
    const [manualSearch, setManualSearch] = useState(false); // State for "Activar Buscador Manual"
    const [isElectronProduction, setIsElectronProduction] = useState(false); // State for Electron Environment (false=Local, true=Produccion)
    // Estados adicionales para contabilización y diseño de etiquetas
    // ...existing code...
    const [initialLabelCount, setInitialLabelCount] = useState(''); // Número inicial de etiquetas
    const [isEditingInitialLabel, setIsEditingInitialLabel] = useState(false);
    const [tempInitialLabelCount, setTempInitialLabelCount] = useState(initialLabelCount);
    const [impresionesRealizadas, setImpresionesRealizadas] = useState(0); // Impresiones realizadas
    const [etiquetasRestantes, setEtiquetasRestantes] = useState(0);
    const [actualizandoEstadisticas, setActualizandoEstadisticas] = useState(false);
    const navigate = useNavigate(); 

    async function fetchPrinters() {
        const button = document.getElementById('btnBuscarImpresora');
        if (button) button.disabled = true;
        if (!window.eventos) {
            if (button) button.disabled = false;
            return tools.notie.alert({
                type: 'error',
                text: 'No fue posible recuperar las impresoras instaladas en el sistema.',
                time: 5,
            });
        }
        try {
            let impresoras = await window.eventos.getPrinters();
            console.log('Respuesta de getPrinters:', impresoras);
            
            if (impresoras && impresoras.error) {
                console.error('Error en getPrinters:', impresoras.error);
                if (button) button.disabled = false;
                return tools.notie.alert({
                    type: 'error',
                    text: 'Error al obtener impresoras: ' + impresoras.error,
                    time: 5,
                });
            }
            
            if (!impresoras || !Array.isArray(impresoras) || impresoras.length === 0) {
                console.warn('No se encontraron impresoras');
                if (button) button.disabled = false;
                return tools.notie.alert({
                    type: 'warning',
                    text: 'No se encontraron impresoras instaladas en el sistema. Asegúrate de que tengas impresoras configuradas.',
                    time: 5,
                });
            }
            
            const transformedDevices = impresoras.map(impresora => ({
                clave: impresora.name,
                label: impresora.name,
                value: impresora.name
            }));
            setPrinters(transformedDevices);

            const isPrinterDetected = impresoras.some(printer => printer.name === selectedPrinterEtiquetas);
            setPrinterStatus(isPrinterDetected);

            if (button) button.disabled = false;
            
            tools.notie.alert({
                type: 'success',
                text: `Se encontraron ${impresoras.length} impresoras disponibles.`,
                time: 3,
            });
            
        } catch (error) {
            console.error('Error al llamar getPrinters:', error);
            if (button) button.disabled = false;
            return tools.notie.alert({
                type: 'error',
                text: 'Error inesperado al buscar impresoras: ' + error.message,
                time: 5,
            });
        }
    };

    function selectEve(value){
        setSelectedEvent(value)
        console.log(467, value)
        fetch('/rt_ctg_psp', {
            method: 'POST',
            headers: {"Content-Type":"application/json"},
            body: JSON.stringify({id_eve: value})
        }).then(response => response.json())
        .then(async (response) => {
            console.log(3333, response.psp)
            setPSP(response.psp);
        })
        .catch(async (err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        fetch('/rt_ctg_eve', {
            method: 'POST',
            headers: {"Content-Type":"application/json"}
        }).then(response => response.json())
        .then(async (response) => {
            console.log(3333, response.eventos)
            setEvents(response.eventos);
        })
        .catch(async (err) => {
            console.log(err)
        })
    }, []);

    useEffect(() => {
        let flag = false
        console.log(444, events)
        if(events != null){
            flag = true
        }
    }, [events]);

    useEffect(() => {
        async function loadConfiguration() {
            if (window.eventos) {
                const response = await window.eventos.leerConfiguracion();
                if (response.estado === 'OK' && response.datos) {
                    const config = response.datos;
                    setSelectedEvent(config.selectedEvent || '');
                    setSelectedPSP(config.selectedPSP || '');
                    setSelectedPrinterEtiquetas(config.selectedPrinterEtiquetas || '');
                    setSelectedPrinterDinamicas(config.selectedPrinterDinamicas || '');
                    setLabelWidth(config.labelWidth || '');
                    setLabelHeight(config.labelHeight || '');
                    setTicketWidth(config.ticketWidth || '');
                    setTicketHeight(config.ticketHeight || '');
                    setFontSizeName(config.fontSizeName || '');
                    setFontSizeCompany(config.fontSizeCompany || '');
                    setFontSizeOther(config.fontSizeOther || '');
                    setIsMesaExpositor(config.isMesaExpositor || false); 
                    setManualSearch(config.manualSearch || false); 
                    setIsElectronProduction(config.isElectronProduction || false); // Load Electron environment
                    // ...existing code...
                    setInitialLabelCount(config.initialLabelCount || '');
                    // Buscar impresoras si hay alguna configurada
                    if (config.selectedPrinterEtiquetas || config.selectedPrinterDinamicas) {
                        fetchPrinters();
                    }
                }

                // Cargar estadísticas de impresiones
                await cargarEstadisticasImpresiones();
            }
        }
        loadConfiguration();
        initializeTooltips(); // Initialize tooltips on mount
        return () => {
            if (window.bootstrap && window.bootstrap.Tooltip) {
                const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                tooltipTriggerList.forEach(tooltipTriggerEl => {
                    const tooltipInstance = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                    if (tooltipInstance) {
                        tooltipInstance.dispose();
                    }
                });
            }
        };
    }, []);

    useEffect(() => {
        // Re-initialize tooltips if isElectronProduction changes,
        // or to ensure they are correctly initialized if Bootstrap JS loaded late.
        initializeTooltips();
    }, [isElectronProduction]); 

    useEffect(() => {
        const checkPrinterStatus = async () => {
            if (!window.eventos || !selectedPrinterEtiquetas) {
                setPrinterStatus(null); // No printer selected
                return;
            }
            let impresoras = await window.eventos.getPrinters();
            const isPrinterDetected = impresoras.some(printer => printer.name === selectedPrinterEtiquetas);
            setPrinterStatus(isPrinterDetected); 
        };
        checkPrinterStatus();
    }, [selectedPrinterEtiquetas]);

    const handleSave = async () => {
        const configData = {
            selectedEvent,
            selectedPSP,
            selectedPrinterEtiquetas,
            selectedPrinterDinamicas,
            labelWidth,
            labelHeight,
            ticketWidth,
            ticketHeight,
            fontSizeName,
            fontSizeCompany,
            fontSizeOther,
            isMesaExpositor, 
            manualSearch,
            isElectronProduction,
            // ...existing code...
            initialLabelCount
        };
        if (window.eventos) {
            const response = await window.eventos.guardarConfiguracion(configData);
            if (response.estado === 'OK') {
                fetch('/rt_guardar_configuracion_mesa', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ configData }) 
                });
                tools.notie.alert({
                    type: 'success',
                    text: 'Configuración guardada exitosamente.',
                    time: 3,
                    position: 'top'
                });
            } else {
                tools.notie.alert({
                    type: 'error',
                    text: `Error al guardar configuración: ${response.mensaje}`,
                    time: 3,
                    position: 'top'
                });
            }
        }else{
            tools.notie.alert({
                type: 'error',
                text: `Error al guardar configuración: No es posible guardar la configuración desde este navegador.`,
                time: 3,
                position: 'top'
            });
        }
    };

    // Lógica para cargar estadísticas de impresiones
    async function cargarEstadisticasImpresiones() {
        if (window.eventos) {
            try {
                setActualizandoEstadisticas(true);
                
                // Obtener impresiones realizadas
                const impressionsResponse = await window.eventos.getImpresionesLocales();
                const impresionesCount = impressionsResponse?.count || 0;
                console.log('📊 Datos cargados:', { impressionsResponse, impresionesCount });
                setImpresionesRealizadas(impresionesCount);

                // Obtener número inicial de etiquetas
                const initialResponse = await window.eventos.leerInitialLabelCount();
                const initialCount = initialResponse?.count || 0;
                console.log('🏷️ Número inicial:', { initialResponse, initialCount });
                
                // Calcular etiquetas restantes
                const restantes = Math.max(0, initialCount - impresionesCount);
                console.log('🧮 Cálculo final:', { initialCount, impresionesCount, restantes });
                setEtiquetasRestantes(restantes);
            } catch (error) {
                console.error('Error cargando estadísticas de impresiones:', error);
                setImpresionesRealizadas(0);
                setEtiquetasRestantes(0);
            } finally {
                setActualizandoEstadisticas(false);
            }
        }
    }

    useEffect(() => {
        setTempInitialLabelCount(initialLabelCount);
    }, [initialLabelCount]);

    const handleReturn = () => {
        navigate('/mesaregistro');
    };

    const handleLabelWidthChange = (e) => {
        const value = e.target.value;
        setLabelWidth(value);
    };

    const handleLabelHeightChange = (e) => {
        const value = e.target.value;
        setLabelHeight(value);
    };

    const handleElectronEnvChange = (targetIsProduction) => {
        if (targetIsProduction !== isElectronProduction) {
            const message = targetIsProduction
                ? "Está a punto de cambiar el entorno a Producción. Esta configuración puede afectar la impresión de etiquetas. ¿Desea continuar?"
                : "Está a punto de cambiar el entorno a Local. Esta configuración puede afectar la impresión de etiquetas. ¿Desea continuar?";

            tools.notie.confirm({
                text: message,
                submitText: 'Sí',
                cancelText: 'No',
                position: 'top',
                submitCallback: () => {
                    setIsElectronProduction(targetIsProduction);
                },
                cancelCallback: () => {
                    console.log('Cambio de entorno Electron cancelado.');
                }
            });
        }
    };

    const initializeTooltips = () => {
        if (window.bootstrap && window.bootstrap.Tooltip) {
            const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            
            // Dispose any existing tooltips on these elements first
            tooltipTriggerList.forEach(tooltipTriggerEl => {
                const existingTooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                if (existingTooltip) {
                    existingTooltip.dispose();
                }
            });

            // Initialize new tooltips
            tooltipTriggerList.forEach(tooltipTriggerEl => {
                new window.bootstrap.Tooltip(tooltipTriggerEl);
            });
        } else {
            console.warn('Bootstrap Tooltip JS (window.bootstrap.Tooltip) not available. Tooltips will not work.');
            if (!window.bootstrap) {
                console.warn('window.bootstrap itself is not available. Ensure Bootstrap JavaScript is loaded before this component.');
            }
        }
    };

    return (
        <div className="container d-flex justify-content-center" style={{ maxWidth: '80%', backgroundColor: '#f2f2f5', color: '#000' }}>
            <Fragment>
                <button 
                    onClick={handleReturn} 
                    className="btn btn-secondary" 
                    style={{ position: 'absolute', top: '10px', left: '10px' }}
                >
                    Regresar
                </button>
                {/* <Loader status={events}/> */}
                <div className="col-sm-10 mt-5 registros-nuevos"> {/* Adjusted width */}
                    <div className="card mt-5" style={{ backgroundColor: '#fff', color: '#000' }}>
                        <div className="card-header p-0 mt-3">
                            <div className='row p-0 m-0 d-flex justify-content-center'>
                                <div className="col-sm-10 p-0 m-0 d-flex justify-content-center">
                                    <h5>Configuración</h5> {/* Updated title */}
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            {/* New "Configuración General" section */}
                            <div className="row mb-4" style={{ paddingLeft: '15px' }}>
                                <div className="col-md-12">
                                    <h5>Configuración General</h5>
                                    <div className="d-flex align-items-center mb-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            id="isMesaExpositor"
                                            checked={isMesaExpositor}
                                            onChange={(e) => setIsMesaExpositor(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="isMesaExpositor">
                                            Es Mesa Expositor
                                        </label>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            id="manualSearch"
                                            checked={manualSearch}
                                            onChange={(e) => setManualSearch(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="manualSearch">
                                            Activar Buscador Manual
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            {/* Configuración de Impresoras Section  */}
                            <div className="row mb-4">
                                <div className="col-md-12">
                                    <h5>Configuración de Impresoras</h5>
                                    <button id="btnBuscarImpresora" onClick={fetchPrinters} className="btn btn-primary mb-2">Buscar Impresora</button>
                                </div>
                            </div>
                            <hr /> {/* Separator */}
                            {/* Contabilización de etiquetas Section */}
                            <div className="row mb-4">
                                <div className="col-md-8">
                                    <h5>Contabilización de etiquetas</h5>
                                    <div className="d-flex align-items-center" style={{ gap: '15px' }}>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Número inicial de etiquetas"
                                            value={isEditingInitialLabel ? tempInitialLabelCount : initialLabelCount}
                                            onChange={e => setTempInitialLabelCount(e.target.value)}
                                            style={{ width: '40%' }}
                                            min="0"
                                            disabled={!isEditingInitialLabel}
                                        />
                                        <button
                                            className="btn btn-warning text-white"
                                            type="button"
                                            onClick={() => setIsEditingInitialLabel(true)}
                                            disabled={isEditingInitialLabel}
                                            title="Editar número inicial de etiquetas"
                                        >
                                            EDITAR
                                        </button>
                                        {isEditingInitialLabel && (
                                            <button
                                                className="btn btn-success text-white"
                                                type="button"
                                                onClick={async () => {
                                                    tools.notie.confirm({
                                                        text: 'Si modificas este número se va a reiniciar el conteo de etiquetas restantes. ¿Deseas continuar?',
                                                        submitText: 'Sí',
                                                        cancelText: 'No',
                                                        position: 'top',
                                                        submitCallback: async () => {
                                                            setInitialLabelCount(tempInitialLabelCount);
                                                            setIsEditingInitialLabel(false);
                                                            // Lógica para guardar y reiniciar contador
                                                            if (window.eventos) {
                                                                const response = await window.eventos.leerConfiguracion();
                                                                let config = response.datos || {};
                                                                config.initialLabelCount = tempInitialLabelCount;
                                                                await window.eventos.guardarConfiguracion(config);
                                                                // También guardar en archivo separado para estadísticas
                                                                if (window.eventos.resetImpresionesLocales) {
                                                                    await window.eventos.resetImpresionesLocales(tempInitialLabelCount);
                                                                } else if (window.electron && window.electron.invoke) {
                                                                    await window.electron.invoke('resetImpresionesLocales', tempInitialLabelCount);
                                                                } else if (window.ipcRenderer) {
                                                                    await window.ipcRenderer.invoke('resetImpresionesLocales', tempInitialLabelCount);
                                                                }
                                                                // Recargar estadísticas después del reset
                                                                await cargarEstadisticasImpresiones();
                                                                tools.notie.alert({
                                                                    type: 'success',
                                                                    text: 'Número inicial de etiquetas actualizado y contador reiniciado.',
                                                                    time: 3,
                                                                    position: 'top'
                                                                });
                                                            }
                                                        },
                                                        cancelCallback: () => {
                                                            setTempInitialLabelCount(initialLabelCount);
                                                            setIsEditingInitialLabel(false);
                                                        }
                                                    });
                                                }}
                                                title="Guardar número inicial de etiquetas"
                                            >
                                                GUARDAR
                                            </button>
                                        )}
                                    </div>
                                    {/* Estadísticas en tiempo real */}
                                    <div className="mt-4">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="card" style={{ backgroundColor: '#e3f2fd', border: '1px solid #90caf9' }}>
                                                    <div className="card-body text-center">
                                                        <h4 className="card-title" style={{ color: '#1976d2' }}>{impresionesRealizadas}</h4>
                                                        <p className="card-text mb-0">Impresiones realizadas</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="card" style={{ backgroundColor: etiquetasRestantes > 0 ? '#e8f5e8' : '#ffebee', border: `1px solid ${etiquetasRestantes > 0 ? '#4caf50' : '#f44336'}` }}>
                                                    <div className="card-body text-center">
                                                        <h4 className="card-title" style={{ color: etiquetasRestantes > 0 ? '#2e7d32' : '#d32f2f' }}>{etiquetasRestantes}</h4>
                                                        <p className="card-text mb-0">Etiquetas restantes</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="card" style={{ backgroundColor: '#f3e5f5', border: '1px solid #ba68c8' }}>
                                                    <div className="card-body text-center">
                                                        <h4 className="card-title" style={{ color: '#7b1fa2' }}>{initialLabelCount || 0}</h4>
                                                        <p className="card-text mb-0">Total configurado</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-2 text-center">
                                            <button 
                                                className="btn btn-info btn-sm"
                                                onClick={cargarEstadisticasImpresiones}
                                                title="Actualizar estadísticas"
                                                disabled={actualizandoEstadisticas}
                                            >
                                                {actualizandoEstadisticas ? '🔄 Actualizando...' : '🔄 Actualizar'}
                                            </button>
                                            <small className="d-block mt-2 text-muted">
                                                {actualizandoEstadisticas ? 'Cargando datos...' : 'Haz clic para actualizar las estadísticas manualmente'}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4"></div>
                            </div>
                            <hr />
                            {/* Configuración de Etiquetas Section */}
                            <div className="row mb-4">
                                <div className="col-md-8">
                                    <h5>Configuración de Etiquetas</h5>
                                    <div className="d-flex" style={{ gap: '25px' }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Ancho de etiqueta (mm)"
                                            value={labelWidth}
                                            onChange={handleLabelWidthChange}
                                            style={{ width: '20%' }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Alto de etiqueta (mm)"
                                            value={labelHeight}
                                            onChange={handleLabelHeightChange}
                                            style={{ width: '20%' }}
                                        />
                                    </div>
                                    <div className="mt-2">
                                        <Select
                                            placeholder="Seleccione una impresora para etiquetas"
                                            style={{ width: '30%' }}
                                            datos={printers}
                                            value={selectedPrinterEtiquetas}
                                            onChange={(e) => setSelectedPrinterEtiquetas(e.e.target.value)}
                                            isDisabled={printers.length === 0}
                                        />
                                    </div>
                                    <div className="mt-2">
                                        <span>Estado de la impresora seleccionada: </span>
                                        <span style={{
                                            display: 'inline-block',
                                            width: '15px',
                                            height: '15px',
                                            borderRadius: '50%',
                                            backgroundColor: printerStatus === null ? 'gray' : printerStatus ? 'green' : 'red',
                                            marginLeft: '10px'
                                        }}></span>
                                        <span style={{ marginLeft: '10px' }}>
                                            {printerStatus === null
                                                ? 'No seleccionada'
                                                : printerStatus
                                                ? 'Conectada'
                                                : 'Desconectada'}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center justify-content-center">
                                    {/* <div
                                        className="contenedor"
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            width: labelWidth ? `${labelWidth}mm` : '150px',
                                            height: labelHeight ? `${labelHeight}mm` : '100px',
                                        }}
                                    >
                                    </div> */}
                                </div>
                            </div>
                            <hr />
                            {/* ...existing code... */}
                            {/* Configuración Electron section - Moved to the end of configuration groups */}
                            <div className="row mb-4" style={{ paddingLeft: '15px' }}>
                                <div className="col-md-12">
                                    <h5>Configuración Electron</h5>
                                    <div className="d-flex align-items-center">
                                        <span className="me-2">Local</span>
                                        <label className="modern-checkbox mx-2" htmlFor="electronEnvSwitch">
                                            <input
                                                type="checkbox"
                                                id="electronEnvSwitch"
                                                checked={isElectronProduction}
                                                onChange={(e) => handleElectronEnvChange(e.target.checked)}
                                            />
                                            <span 
                                                className="checkmark"
                                                style={{ 
                                                    backgroundColor: isElectronProduction ? 'red' : '#0d6efd' 
                                                }}
                                            ></span>
                                        </label>
                                        <span className="me-2">Producción</span>
                                        <span 
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="Define el entorno de ejecución para la aplicación. 'Local' para desarrollo y pruebas, 'Producción' para el entorno de despliegue final."
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <i className="bi bi-info-circle-fill"></i> {/* Ensure Bootstrap Icons CSS is linked in your project */}
                                        </span>
                                    </div>
                                    <small className="form-text text-muted mt-1 d-block">
                                        Esta configuración afecta solamente la ruta que se consulta para imprimir etiquetas.
                                    </small>
                                </div>
                            </div>
                            <hr />
                            <div className="row mb-4">
                                <div className="col-md-12 d-flex justify-content-center">
                                    <button onClick={() => handleSave()} className="btn btn-success">Guardar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        </div>
    );
};

export default Default;